<template>
   <div data-cy="company-logo" class="max-h-inherit">
      <span v-if="organisationInfo" class="sr-only">{{
         $t("redirects.logo_link_to_home", { organisation: organisationInfo.name })
      }}</span>
      <img v-if="viteAppOrg" :src="getImage()" alt="" />
   </div>
</template>

<script setup lang="ts">
import { useBaseContentStore } from "@/stores/baseContentStore";
import { useI18n } from "@/vue-i18n/vue-i18n";

const { t: $t } = useI18n();
const baseContentStore = useBaseContentStore();

const viteAppOrg = import.meta.env.VITE_APP_ORG as string;

// Computed values
const organisationInfo = computed(() => {
   if (!baseContentStore.content) return null;

   return baseContentStore.content.organisationInfo;
});

// Methods
function getImage() {
   return new URL(`../../assets/images/org-logos/${viteAppOrg}.svg`, import.meta.url).href;
}
</script>
